// import { useState } from "react";
// import { motion } from "framer-motion";
// import Overlay from "./Overlay"; // Import the overlay

// const CourseCard = ({ course }) => {
//     const [isOverlayOpen, setIsOverlayOpen] = useState(false);
//     const [isPopupVisible, setIsPopupVisible] = useState(false);


//     return (
//         <>
//             <motion.div
//                 className="course-card"
//                 onClick={() => setIsOverlayOpen(true)} // Open overlay on click
//                 initial={{ opacity: 0, y: 50 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.7 }}
//             >
//                 <motion.div className="card-inner">
//                     <motion.div className="card-front">
//                         <img src={`/images/${course.image}`} alt={course.name} className="course-image" />
//                     </motion.div>
//                     <h3>{course.name}</h3>
//                     <p>{course.desc}</p>

//                     {/* Green "Get Started" Button inside the card */}
//                     <button
//                         className="get-started-btn"
//                         onClick={() => setIsOverlayOpen(true)}
//                     >
//                         Get Started
//                     </button>
//                 </motion.div>
//             </motion.div>

//             {/* Show overlay as a separate layer */}
//             {isOverlayOpen && <Overlay course={course} onClose={() => setIsOverlayOpen(false)} />}
//         </>
//     );
// };

// export default CourseCard;


import { useState } from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Box,
} from "@mui/material";
import { motion } from "framer-motion";
import Overlay from "./Overlay";

const CourseCard = ({ course }) => {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);

  return (
    <>
      <motion.div
  initial={{ opacity: 0, y: 50 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.7 }}
>
  <Box
    sx={{
      width: "70vw",           // Make full screen width
      display: "flex",
      justifyContent: "center", // Center the card horizontally
    }}
  >
    <Card
      onClick={() => setIsOverlayOpen(true)}
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: "95%",            // Allow responsive sizing
        maxWidth: 1500,
        minHeight: 180,
        borderRadius: 3,
        backgroundColor: "rgba(190, 208, 235, 0.84)",
        boxShadow: 3,
        cursor: "pointer",
        transition: "0.3s",
        "&:hover": {
          boxShadow: 6,
          transform: "scale(1.02)",
        },
        my: 2,
      }}
    >
      <CardMedia
        component="img"
        image={`/images/${course.image}`}
        alt={course.name}
        sx={{
          width: 230,
          height: 180,
          objectFit: "cover",
          borderRadius: 7,
          p: 2,
        }}
      />
      <CardContent sx={{ flex: 1 }}>
        <Typography variant="h6" component="div" gutterBottom>
          {course.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {course.desc}
        </Typography>
        <Button
          variant="contained"
          color="success"
          size="small"
          onClick={(e) => {
            e.stopPropagation(); // prevent card click from firing
            setIsOverlayOpen(true);
          }}
          sx={{ mt: 2 }}
        >
          Get Started
        </Button>
      </CardContent>
    </Card>
  </Box>
</motion.div>


      {isOverlayOpen && (
        <Overlay course={course} onClose={() => setIsOverlayOpen(false)} />
      )}
    </>
  );
};

export default CourseCard;
